module.exports = __webpack_public_path__ + "img/9788958071846.9a2761c1.jpg";